import { useCallback } from 'react';
import { useParams } from 'react-router';

import { useInboxEntryPanel } from '../../store/inboxEntryPanel.store';
import { RawInboxEntry } from '../../types';
import { updateSidebarInboxEntry } from '../Sidebar/api/inboxEntries';
import { mapInboxEntry } from '../Sidebar/InboxEntry/InboxEntry';

export default function useSyncInboxEntry() {
  const { setInboxEntry } = useInboxEntryPanel();
  const { projectId } = useParams<{ projectId: string }>();

  const handleSyncSidebbarInboxEntryToEntryPanel = useCallback(
    (rawInboxEntry: RawInboxEntry) => {
      updateSidebarInboxEntry({ projectId, newInboxEntry: rawInboxEntry });
      setInboxEntry(mapInboxEntry(rawInboxEntry));
    },
    [projectId, setInboxEntry]
  );

  return handleSyncSidebbarInboxEntryToEntryPanel;
}
